module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-8-409b8edf73e6192634e9b08cc3450178.png";